import useNetworks, { useNetworkDecimal } from '#/data/useNetworks';
import formatUnits from '#/utils/formatUnits';
import { ethers } from 'ethers';
import { useMemo } from 'react';
import Skeleton from './Skeleton';

interface Props {
  symbol?: string;
  value?: string;
  /**
   * 最大小数位数
   */
  maxDecimalDigits?: number;
  noSymbol?: boolean;
}

export default function NetworkValue({
  symbol,
  value,
  maxDecimalDigits,
  noSymbol = false,
}: Props) {
  const { isLoading } = useNetworks();
  const decimal = useNetworkDecimal(symbol);
  const resultAsBigNumber = useMemo(
    () => (value ? ethers.BigNumber.from(value) : null),
    [value]
  );
  const valueAsString = useMemo(
    () =>
      decimal != null && resultAsBigNumber
        ? ethers.utils.commify(
            formatUnits(resultAsBigNumber, decimal, maxDecimalDigits)
          )
        : null,
    [value, decimal]
  );
  return (
    <Skeleton isLoading={isLoading} className="w-32">
      <span className="whitespace-nowrap">
        {valueAsString}
        {!noSymbol && <> {symbol}</>}
      </span>
    </Skeleton>
  );
}
